import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getRelationshipManagers } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchRelationshipManagers(): Promise<APIResult> {
  const response = await fetch(getRelationshipManagers, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<{
    Id: number;
    FirstName: string;
    LastName: string;
    Phone?: string;
    Email?: string;
  }>;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetRelationshipManagers(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_relationship_managers',
    async () => {
      const fetchResponse = await fetchRelationshipManagers();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: `${item.FirstName} ${item.LastName}`,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetRelationshipManagers };
